export enum UserRoles {
  ACCOUNT_EXECUTIVE = 'ACCOUNT_EXECUTIVE',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export const ROLE_ENUM_TO_LABEL_MAP = [
  {
    role: UserRoles.ACCOUNT_EXECUTIVE,
    label: 'account-executive-role-label',
  },
  {
    role: UserRoles.SUPER_ADMIN,
    label: 'super-admin-role-label',
  },
  {
    role: UserRoles.ADMIN,
    label: 'admin-role-label',
  },
  {
    role: UserRoles.ACCOUNT_MANAGER,
    label: 'account-manager-role-label',
  },
];

export const isAdminRole = (role: string): boolean =>
  role === UserRoles.ADMIN || role === UserRoles.SUPER_ADMIN;

